import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const quickLinks = [
    { label: 'AllChinaBuy Spreadsheet', href: '/allchinabuy-spreadsheet' },
    { label: 'AllChinaBuy Review', href: '/allchinabuy-review' },
    { label: 'Shipping Cost', href: '/allchinabuy-shipping-cost' },
    { label: 'Coupon Guide', href: '/allchinabuy-coupon' },
    { label: 'Is AllChinaBuy Legit?', href: '/is-allchinabuy-legit' },
    { label: 'Warehouse Guide', href: '/allchinabuy-warehouse' },
    { label: 'QC Guide', href: '/allchinabuy-qc-guide' },
    { label: 'Beginner Guide', href: '/allchinabuy-beginner-guide' },
  ];

  const categories = [
    { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html' },
    { label: 'Hoodies & Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
    { label: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
    { label: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
    { label: 'Pants & Shorts', href: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
    { label: 'Accessories', href: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
    { label: 'Bags', href: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
    { label: 'Other Stuff', href: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
  ];

  return (
    <footer className="bg-stone-100 border-t border-stone-200">
      <div className="w-full px-6 lg:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <h3 className="text-lg font-bold text-stone-900 mb-3" style={{ fontFamily: 'var(--font-heading, serif)' }}>
              AllChinaBuy
            </h3>
            <p className="text-sm text-stone-500 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-stone-900 uppercase tracking-wider mb-4">
              {t('footer.links')}
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-stone-500 hover:text-stone-900 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-stone-900 uppercase tracking-wider mb-4">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.href}>
                  <a
                    href={cat.href}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-stone-500 hover:text-stone-900 transition-colors"
                  >
                    {cat.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-stone-900 uppercase tracking-wider mb-4">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="/privacy" className="text-sm text-stone-500 hover:text-stone-900 transition-colors">
                  {t('footer.privacy')}
                </a>
              </li>
              <li>
                <a href="/terms" className="text-sm text-stone-500 hover:text-stone-900 transition-colors">
                  {t('footer.terms')}
                </a>
              </li>
              <li>
                <a href="/disclaimer" className="text-sm text-stone-500 hover:text-stone-900 transition-colors">
                  {t('footer.disclaimer')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-stone-400">
            {t('footer.copyright')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="text-xs text-stone-500 hover:text-stone-900 transition-colors"
          >
            kaspreadsheet.com
          </a>
        </div>
      </div>
    </footer>
  );
}